import { Component, Input, OnInit } from '@angular/core';
import { CmisEntry, CmisResponse, GbCmisService } from '../../../core/gb-api';
import { Observable } from 'rxjs';
import { CmisDocumentTarget, CmisService } from './cmis.service';
import { AsyncPipe } from '@angular/common';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CmisModalComponent } from './cmisModal/cmis-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cap-cmis',
  templateUrl: './cmis.component.html',
  styleUrls: ['./cmis.component.scss'],
  imports: [NgbTooltip, AsyncPipe]
})
export class CmisComponent implements OnInit {
  @Input() target!: CmisDocumentTarget;

  documents$!: Observable<CmisResponse>;

  protected tooltip: string;
  protected hasPermission = false;

  private isModalOpen = false;

  constructor(
    private cmisService: CmisService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private api: GbCmisService
  ) {}

  ngOnInit() {
    if (this.target && this.target.itemType && this.target.id) {
      this.tooltip = this.translate.instant('DokumenteZu' + this.target.itemType, { param: this.target.tooltipParam });
      this.documents$ = this.cmisService.getDocuments(this.target);
      this.hasPermission = this.cmisService.hasPermission(this.target.itemType);
    }
  }

  openDocument(entry: CmisEntry) {
    this.api.downloadCmisDocument(entry.cmisId).subscribe((value) => {
      const url = URL.createObjectURL(value);
      window.open(url, '_blank');
    });
  }

  openDialog(entries: Array<CmisEntry>) {
    if (this.isModalOpen) {
      return;
    }
    this.isModalOpen = true;

    const modalRef = this.modalService.open(CmisModalComponent);
    modalRef.componentInstance.modalTitle = 'Document';
    modalRef.componentInstance.cmisEntries = entries;

    modalRef.result.finally(() => {
      this.isModalOpen = false;
    });

    return modalRef;
  }
}
